const en = {
  hello: 'hello',
  welcome: 'Welcome',
  lang: 'english',
};

export default en;
